var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "ma-0" },
    [
      _c(
        "v-col",
        { staticClass: "wsp-wallpaper pb-5", attrs: { cols: "12" } },
        [
          _c(
            "div",
            { staticClass: "ma-2" },
            [
              _c(
                "v-card",
                { staticClass: "pa-3" },
                [
                  _vm.message.file_id && _vm.getFilesMap[_vm.message.file_id]
                    ? _c("div", [
                        _vm.getFilesMap[_vm.message.file_id].type === "image"
                          ? _c("div", [
                              _c("img", {
                                attrs: {
                                  src: _vm.getFilesMap[_vm.message.file_id].url,
                                  width: "100%",
                                },
                              }),
                            ])
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "pa-2 text-caption text--lighten-2",
                                style: { "background-color": "#eee" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: { size: "x-small" },
                                  },
                                  [_vm._v("fa fa-file")]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getFilesMap[_vm.message.file_id].name
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                      ])
                    : _vm.message.file && _vm.message.file.type === "image"
                    ? _c("div", [
                        _c("img", {
                          attrs: { src: _vm.message.file.url, width: "100%" },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "font-weight-bold text-body-1 pb-1",
                    domProps: {
                      innerHTML: _vm._s(_vm.renderedText(_vm.message.title)),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "text-body-2 mb-0",
                    domProps: {
                      innerHTML: _vm._s(_vm.renderedText(_vm.message.content)),
                    },
                  }),
                  _vm._v(" "),
                  _vm.message.type === "form"
                    ? _vm._l(_vm.message.schema, function (schem, i) {
                        return _c(
                          "div",
                          { key: i, staticClass: "text-body-2" },
                          [_vm._v("- " + _vm._s(schem.label))]
                        )
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    {
                      staticClass:
                        "pa-0 text-caption text--secondary text-right",
                      attrs: { cols: "12" },
                    },
                    [_c("span", [_vm._v("07:42")])]
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _vm.message.options
                ? _c(
                    "div",
                    [
                      _vm.message.options.length > 3
                        ? [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mt-2 info--text",
                                attrs: { block: "", color: "white" },
                                on: { click: _vm.showListOptions },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { "x-small": "", color: "info" },
                                  },
                                  [_vm._v(" fas fa-bars")]
                                ),
                                _vm._v(
                                  "\n            Ver opciones\n          "
                                ),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.message.options.length <= 3
                        ? _vm._l(
                            _vm.message.options,
                            function (button, buttonIndex) {
                              return _c(
                                "div",
                                { key: buttonIndex },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mt-2 info--text",
                                      attrs: { block: "", color: "white" },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(button.title) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.show
            ? _c("DialogComponent", {
                attrs: { message: _vm.message },
                on: { closeDialog: _vm.showListOptions },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }